import {
    SITE_LISTING,
    SITE_FILTERS,
    CHANGE_LOCATION,
    TASK_LISTING,
    SITE_REPOSITORY,
    CREATE_SITE_REPOSITORY,
    TAG_INFO,
    SITE_LISTING_FOR_ASSET,
    SITE_GATES_FOR_ASSET,
    PARENT_MATERIALS,
    ASSETS,
    SAVE_ASSETS,
    ASSET_INFO_DETAILS,
    CONTRACT_GATES_FOR_ASSET,
    PARENT_MATERIALS_CONTRACT,
    CLIENT_CONTRACT_MAPPING,
    TAG_VEHICLE,
    TAG_AUDIT,
    SITE_LISTING_MAINTENANCE,
    PR_LISTING,
    SITE_PR_LISTING,
    SERVICES_QTY,
    SERVICES_QTY_CONFIRMATON,
    PR_CONFIRMATION_DETAILS,
    POS_REPLACE_RETURN,
    DISMANTLE_SITE, DISMANTLE_MRF, CONTRACT_DATE, DISMANTLE_MRF_BY_SITE_ID,
    INSTALLATION_DATE_CHANGE_LIST,
    INSTALLATION_DATE_CHANGE_DETAIL,
    INSTALLATION_DATE_CHANGE_CREATE,
    INSTALLATION_DATE_CHANGE_APPROVAL,
    TAG_INFO_BY_VEHICLE_NO
} from "./type";

const initalState = {
    siteListData: {},
    taskListData: {},
    siteFiltersData: null,
    locationChange: {},
    siteRepository: [],
    createSiteRepository: [],
    tagInfo: [],
    siteListingAsset: {},
    siteGates: {},
    parentMaterials: [],
    assetsData: [],
    assetsInfoData: [],
    contractGates: {},
    parentMaterialsData: [],
    clientAddressesMapping: [],
    prListData: {},
    sitePrListData: {},
    servicesQty: {},
    servicesQtyConfirmation: {},
    prConfirmationDetails: {},
    dismantleSiteResponse : [],
    dismantleMrfResponse : [],
    contractDateResponse : [],
    dismantleMrfViewResponse : [],
    posReplaceReturn : [],
    tagInfoByVehicleNumber: []
};

const siteListingReducer = (state = initalState, action) => {
    const {type, payload} = action;
    switch (type) {
        case SITE_LISTING:
            return {
                ...state,
                siteListData: payload,
            };
        case TASK_LISTING:
            return {
                ...state,
                taskListData: payload,
            };
        case SITE_FILTERS:
            return {
                ...state,
                siteFiltersData: payload,
            };
        case CHANGE_LOCATION:
            return {
                ...state,
                locationChange: payload,
            };
        case SITE_REPOSITORY:
            return {
                ...state,
                siteRepository: payload,
            };
        case CREATE_SITE_REPOSITORY:
            return {
                ...state,
                createSiteRepository: payload,
            };
        case TAG_INFO:
            return {
                ...state,
                tagInfo: payload,
            };
        case TAG_AUDIT:
            return {
                ...state,
                tagAudit: payload,
            };
        case TAG_VEHICLE:
            return {
                ...state,
                tagVehicle: payload,
            };

        case SITE_LISTING_FOR_ASSET:
            return {
                ...state,
                siteListingAsset: payload,
            };
        case SITE_GATES_FOR_ASSET:
            return {
                ...state,
                siteGates: payload,
            };
        case PARENT_MATERIALS:
            return {
                ...state,
                parentMaterials: payload,
            };
        case ASSETS:
            return {
                ...state,
                assetsData: payload,
            };
        case ASSET_INFO_DETAILS:
            return {
                ...state,
                assetsInfoData: payload,
            };
        case CONTRACT_GATES_FOR_ASSET:
            return {
                ...state,
                contractGates: payload,
            };
        case PARENT_MATERIALS_CONTRACT:
            return {
                ...state,
                parentMaterialsData: payload,
            };
        case CLIENT_CONTRACT_MAPPING:
            return {
                ...state,
                clientAddressesMapping: payload,
            };
        case SITE_LISTING_MAINTENANCE:
            return {
                ...state,
                siteListData: payload,
            };
        case PR_LISTING:
            return {
                ...state,
                prListData: payload,
            };
        case SITE_PR_LISTING:
            return {
                ...state,
                sitePrListData: payload,
            };
        case SERVICES_QTY:
            return {
                ...state,
                servicesQty: payload,
            };
        case SERVICES_QTY_CONFIRMATON:
            return {
                ...state,
                servicesQtyConfirmation: payload,
            };
        case PR_CONFIRMATION_DETAILS:
            return {
                ...state,
                prConfirmationDetails: payload,
            };
      case POS_REPLACE_RETURN:
        return {
          ...state,
          posReplaceReturn: payload,
        };
    case SITE_REPOSITORY:
      return {
        ...state,
        siteRepository: payload,
      };
    case CREATE_SITE_REPOSITORY:
      return {
        ...state,
        createSiteRepository: payload,
      };
    case TAG_INFO:
      return {
        ...state,
        tagInfo: payload,
      }; 
      case TAG_AUDIT:
      return {
        ...state,
        tagAudit: payload,
      }; 
      case TAG_VEHICLE:
      return {
        ...state,
        tagVehicle: payload,
      }; 
       
    case SITE_LISTING_FOR_ASSET:
      return {
        ...state,
        siteListingAsset: payload,
      };  
    case SITE_GATES_FOR_ASSET:
      return {
        ...state,
        siteGates: payload,
      };  
    case PARENT_MATERIALS:
      return {
        ...state,
        parentMaterials: payload,
      };
    case ASSETS:
      return {
        ...state,
        assetsData: payload,
      }; 
    case ASSET_INFO_DETAILS:
      return {
        ...state,
        assetsInfoData: payload,
      };
    case CONTRACT_GATES_FOR_ASSET:
      return {
        ...state,
        contractGates: payload,
      };
    case PARENT_MATERIALS_CONTRACT:
      return {
        ...state,
        parentMaterialsData: payload,
      };   
    case CLIENT_CONTRACT_MAPPING:
      return {
        ...state,
        clientAddressesMapping: payload,
      };                 
    case SITE_LISTING_MAINTENANCE:
      return {
        ...state,
        siteListData: payload,
      };  
    case PR_LISTING:
      return {
        ...state,
        prListData: payload,
      };
    case SITE_PR_LISTING:
      return {
        ...state,
        sitePrListData: payload,
      };
    case SERVICES_QTY:
      return {
        ...state,
        servicesQty: payload,
      };
    case SERVICES_QTY_CONFIRMATON:
      return {
        ...state,
        servicesQtyConfirmation: payload,
      }; 
    case PR_CONFIRMATION_DETAILS:
      return {
        ...state,
        prConfirmationDetails: payload,
      };
    case DISMANTLE_SITE:
      return {
        ...state,
        dismantleSiteResponse: payload,
      };
    case DISMANTLE_MRF:
      return {
        ...state,
        dismantleMrfResponse: payload,
      };
    case CONTRACT_DATE:
      return {
        ...state,
        contractDateResponse: payload,
      };
    case DISMANTLE_MRF_BY_SITE_ID:
      return {
        ...state,
        dismantleMrfViewResponse: payload,
      };
    case INSTALLATION_DATE_CHANGE_LIST:
       return {
        ...state,
        installationDateChangeListing: payload
       };
    case INSTALLATION_DATE_CHANGE_DETAIL:
       return {
         ...state,
         installationDateChangeDetail: payload
       };
    case INSTALLATION_DATE_CHANGE_CREATE:
       return {
        ...state,
        installationDateChangeRequest: payload
       };
    case INSTALLATION_DATE_CHANGE_APPROVAL:{
        return {
          ...state,
          installationDateChangeApprove: payload
        }
      };
    case TAG_INFO_BY_VEHICLE_NO:
      return {
          ...state,
          tagInfoByVehicleNumber: payload,
      };  
    default:
      return {
        ...state,
      };
  }
};

export default siteListingReducer;
